import React from 'react';

export function getMenuPosition(ref: React.RefObject<HTMLElement>) {
    if(!ref.current) return undefined;
    const rect = ref.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.top;
    return spaceBelow < 300
        ? {bottom: window.innerHeight - rect.top, left: rect.right}
        : {top: rect.top - 13, left: rect.right};
}
